import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestimonialSectionComponent } from './testimonial-section.component';
import { TestimonialComponent } from './testimonial/testimonial.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MaterialModuleModule } from '../material-module/material-module.module';

const routes: Routes = [
  { path: 'Testimonial', component: TestimonialSectionComponent },
]

@NgModule({
  declarations: [TestimonialSectionComponent, TestimonialComponent],
  imports: [
    CommonModule,
    NgbNavModule,
    HttpClientModule,
    MaterialModuleModule,
    FormsModule,
    RouterModule.forChild(routes)
  ]
})
export class TestimonialModule { }
